import React from 'react';
import { ResultReportViewStore } from 'modules/order/stores';
import { ResultReportTemplate } from 'themes/modules/order/pages';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new ResultReportViewStore(rootStore, componentProps), 'resultReportViewStore')
class ResultReport extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <ResultReportTemplate {...this.props} />;
	}
}

export default ResultReport;
